import { createSvgIcon } from '../../createSvgIcon';

const strokeProps = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.5,
  strokeLinejoin: 'round' as const
};

const strokePropsWithCap = {
  ...strokeProps,
  strokeLinecap: 'round' as const
};

export const FolderIcon = createSvgIcon(
  <>
    <path
      d="M0.75 14.2752V4.59539C0.75 3.37474 0.75 2.76441 0.955414 2.28511C1.21186 1.68785 1.68785 1.21186 2.28511 0.955414C2.76441 0.75 3.36882 0.75 4.59624 0.75H5.01383C5.26632 0.750029 5.51559 0.806611 5.74335 0.91559C5.97111 1.02457 6.17156 1.18318 6.33 1.37977L7.86596 3.28598M7.86596 3.28598H12.5846C13.768 3.28598 14.3598 3.28598 14.812 3.51591C15.2095 3.7187 15.5327 4.04213 15.7351 4.43985C15.9659 4.8921 15.9659 5.48383 15.9659 6.66729V7.51261M7.86596 3.28598H4.97663"
      {...strokePropsWithCap}
    />
    <path
      d="M1.72884 11.3284L1.98075 10.7011C2.60122 9.15673 2.91145 8.38495 3.55813 7.94876C4.2048 7.51257 5.04083 7.51257 6.71119 7.51257H13.5245C15.7968 7.51257 16.9337 7.51257 17.4384 8.25562C17.9439 8.99866 17.5212 10.0486 16.6776 12.15L16.4257 12.7773C15.8052 14.3217 15.495 15.0935 14.8483 15.5297C14.2016 15.9658 13.3656 15.9658 11.6952 15.9658H4.88191C2.60967 15.9658 1.4727 15.9658 0.968045 15.2228C0.46254 14.4806 0.885203 13.4299 1.72884 11.3284Z"
      {...strokeProps}
    />
  </>,
  { displayName: 'FolderIcon', viewBox: '0 0 19 17' }
);
